/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const IncludeAction = {
  ApproveGenesisKyc: "ApproveGenesisKyc",
  AddOrRemoveNodeProvider: "AddOrRemoveNodeProvider",
  CreateServiceNervousSystem: "CreateServiceNervousSystem",
  ExecuteNnsFunction: "ExecuteNnsFunction",
  InstallCode: "InstallCode",
  ManageNeuron: "ManageNeuron",
  ManageNetworkEconomics: "ManageNetworkEconomics",
  Motion: "Motion",
  OpenSnsTokenSwap: "OpenSnsTokenSwap",
  RegisterKnownNeuron: "RegisterKnownNeuron",
  RewardNodeProvider: "RewardNodeProvider",
  RewardNodeProviders: "RewardNodeProviders",
  SetDefaultFollowees: "SetDefaultFollowees",
  SetSnsTokenSwapOpenTimeWindow: "SetSnsTokenSwapOpenTimeWindow",
  StopOrStartCanister: "StopOrStartCanister",
  UpdateCanisterSettings: "UpdateCanisterSettings",
} as const;
export type IncludeAction = ClosedEnum<typeof IncludeAction>;

export const GetApiV3ProposalsIncludeStatus = {
  Unknown: "UNKNOWN",
  Unspecified: "UNSPECIFIED",
  Open: "OPEN",
  Rejected: "REJECTED",
  Adopted: "ADOPTED",
  Executed: "EXECUTED",
  Failed: "FAILED",
} as const;
export type GetApiV3ProposalsIncludeStatus = ClosedEnum<
  typeof GetApiV3ProposalsIncludeStatus
>;

export const IncludeRewardStatus = {
  Unspecified: "UNSPECIFIED",
  AcceptVotes: "ACCEPT_VOTES",
  ReadyToSettle: "READY_TO_SETTLE",
  Settled: "SETTLED",
  Ineligible: "INELIGIBLE",
} as const;
export type IncludeRewardStatus = ClosedEnum<typeof IncludeRewardStatus>;

export const IncludeActionNnsFunction = {
  AddApiBoundaryNodes: "AddApiBoundaryNodes",
  AddFirewallRules: "AddFirewallRules",
  AddNodeToSubnet: "AddNodeToSubnet",
  AddOrRemoveDataCenters: "AddOrRemoveDataCenters",
  AddSnsWasm: "AddSnsWasm",
  AssignNoid: "AssignNoid",
  BitcoinSetConfig: "BitcoinSetConfig",
  BlessReplicaVersion: "BlessReplicaVersion",
  ChangeSubnetMembership: "ChangeSubnetMembership",
  ChangeSubnetTypeAssignment: "ChangeSubnetTypeAssignment",
  ClearProvisionalWhitelist: "ClearProvisionalWhitelist",
  CompleteCanisterMigration: "CompleteCanisterMigration",
  CreateSubnet: "CreateSubnet",
  DeployGuestosToAllSubnetNodes: "DeployGuestosToAllSubnetNodes",
  DeployGuestosToAllUnassignedNodes: "DeployGuestosToAllUnassignedNodes",
  DeployGuestosToSomeApiBoundaryNodes: "DeployGuestosToSomeApiBoundaryNodes",
  DeployHostosToSomeNodes: "DeployHostosToSomeNodes",
  HardResetNnsRootToVersion: "HardResetNnsRootToVersion",
  IcpXdrConversionRate: "IcpXdrConversionRate",
  InsertSnsWasmUpgradePathEntries: "InsertSnsWasmUpgradePathEntries",
  NnsCanisterInstall: "NnsCanisterInstall",
  NnsCanisterUpgrade: "NnsCanisterUpgrade",
  NnsRootUpgrade: "NnsRootUpgrade",
  PrepareCanisterMigration: "PrepareCanisterMigration",
  RecoverSubnet: "RecoverSubnet",
  RemoveApiBoundaryNodes: "RemoveApiBoundaryNodes",
  RemoveFirewallRules: "RemoveFirewallRules",
  RemoveNodeOperators: "RemoveNodeOperators",
  RemoveNodes: "RemoveNodes",
  RemoveNodesFromSubnet: "RemoveNodesFromSubnet",
  RerouteCanisterRanges: "RerouteCanisterRanges",
  RetireReplicaVersion: "RetireReplicaVersion",
  ReviseElectedGuestosVersions: "ReviseElectedGuestosVersions",
  ReviseElectedHostosVersions: "ReviseElectedHostosVersions",
  SetAuthorizedSubnetworks: "SetAuthorizedSubnetworks",
  SetFirewallConfig: "SetFirewallConfig",
  StopOrStartNnsCanister: "StopOrStartNnsCanister",
  SubnetRentalRequest: "SubnetRentalRequest",
  UninstallCode: "UninstallCode",
  Unspecified: "Unspecified",
  UpdateAllowedPrincipals: "UpdateAllowedPrincipals",
  UpdateApiBoundaryNodesVersion: "UpdateApiBoundaryNodesVersion",
  UpdateConfigOfSubnet: "UpdateConfigOfSubnet",
  UpdateElectedHostosVersions: "UpdateElectedHostosVersions",
  UpdateFirewallRules: "UpdateFirewallRules",
  UpdateNodeOperatorConfig: "UpdateNodeOperatorConfig",
  UpdateNodeRewardsTable: "UpdateNodeRewardsTable",
  UpdateNodesHostosVersion: "UpdateNodesHostosVersion",
  UpdateSnsWasmSnsSubnetIds: "UpdateSnsWasmSnsSubnetIds",
  UpdateSshReadonlyAccessForAllUnassignedNodes:
    "UpdateSshReadonlyAccessForAllUnassignedNodes",
  UpdateSubnetType: "UpdateSubnetType",
  UpdateUnassignedNodesConfig: "UpdateUnassignedNodesConfig",
} as const;
export type IncludeActionNnsFunction = ClosedEnum<
  typeof IncludeActionNnsFunction
>;

export const GetApiV3ProposalsFormat = {
  Json: "json",
  Csv: "csv",
} as const;
export type GetApiV3ProposalsFormat = ClosedEnum<
  typeof GetApiV3ProposalsFormat
>;

export const GetApiV3ProposalsIncludeTopic = {
  TopicUnspecified: "TOPIC_UNSPECIFIED",
  TopicNeuronManagement: "TOPIC_NEURON_MANAGEMENT",
  TopicExchangeRate: "TOPIC_EXCHANGE_RATE",
  TopicNetworkEconomics: "TOPIC_NETWORK_ECONOMICS",
  TopicGovernance: "TOPIC_GOVERNANCE",
  TopicNodeAdmin: "TOPIC_NODE_ADMIN",
  TopicParticipantManagement: "TOPIC_PARTICIPANT_MANAGEMENT",
  TopicSubnetManagement: "TOPIC_SUBNET_MANAGEMENT",
  TopicNetworkCanisterManagement: "TOPIC_NETWORK_CANISTER_MANAGEMENT",
  TopicKyc: "TOPIC_KYC",
  TopicNodeProviderRewards: "TOPIC_NODE_PROVIDER_REWARDS",
  TopicSnsDecentralizationSale: "TOPIC_SNS_DECENTRALIZATION_SALE",
  TopicIcOsVersionDeployment: "TOPIC_IC_OS_VERSION_DEPLOYMENT",
  TopicIcOsVersionElection: "TOPIC_IC_OS_VERSION_ELECTION",
  TopicSnsAndCommunityFund: "TOPIC_SNS_AND_COMMUNITY_FUND",
  TopicApiBoundaryNodeManagement: "TOPIC_API_BOUNDARY_NODE_MANAGEMENT",
  TopicSubnetRental: "TOPIC_SUBNET_RENTAL",
  TopicProtocolCanisterManagement: "TOPIC_PROTOCOL_CANISTER_MANAGEMENT",
  TopicServiceNervousSystemManagement:
    "TOPIC_SERVICE_NERVOUS_SYSTEM_MANAGEMENT",
  TopicSystemCanisterManagement: "TOPIC_SYSTEM_CANISTER_MANAGEMENT",
  TopicApplicationCanisterManagement: "TOPIC_APPLICATION_CANISTER_MANAGEMENT",
} as const;
export type GetApiV3ProposalsIncludeTopic = ClosedEnum<
  typeof GetApiV3ProposalsIncludeTopic
>;

export type GetApiV3ProposalsRequest = {
  limit?: number | undefined;
  maxProposalIndex?: number | null | undefined;
  includeAction?: Array<IncludeAction> | undefined;
  includeStatus?: Array<GetApiV3ProposalsIncludeStatus> | undefined;
  proposer?: number | null | undefined;
  manageNeuronId?: number | null | undefined;
  offset?: number | undefined;
  includeRewardStatus?: Array<IncludeRewardStatus> | undefined;
  includeActionNnsFunction?: Array<IncludeActionNnsFunction> | undefined;
  format?: GetApiV3ProposalsFormat | undefined;
  includeTopic?: Array<GetApiV3ProposalsIncludeTopic> | undefined;
};

/** @internal */
export const IncludeAction$inboundSchema: z.ZodNativeEnum<
  typeof IncludeAction
> = z.nativeEnum(IncludeAction);

/** @internal */
export const IncludeAction$outboundSchema: z.ZodNativeEnum<
  typeof IncludeAction
> = IncludeAction$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace IncludeAction$ {
  /** @deprecated use `IncludeAction$inboundSchema` instead. */
  export const inboundSchema = IncludeAction$inboundSchema;
  /** @deprecated use `IncludeAction$outboundSchema` instead. */
  export const outboundSchema = IncludeAction$outboundSchema;
}

/** @internal */
export const GetApiV3ProposalsIncludeStatus$inboundSchema: z.ZodNativeEnum<
  typeof GetApiV3ProposalsIncludeStatus
> = z.nativeEnum(GetApiV3ProposalsIncludeStatus);

/** @internal */
export const GetApiV3ProposalsIncludeStatus$outboundSchema: z.ZodNativeEnum<
  typeof GetApiV3ProposalsIncludeStatus
> = GetApiV3ProposalsIncludeStatus$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3ProposalsIncludeStatus$ {
  /** @deprecated use `GetApiV3ProposalsIncludeStatus$inboundSchema` instead. */
  export const inboundSchema = GetApiV3ProposalsIncludeStatus$inboundSchema;
  /** @deprecated use `GetApiV3ProposalsIncludeStatus$outboundSchema` instead. */
  export const outboundSchema = GetApiV3ProposalsIncludeStatus$outboundSchema;
}

/** @internal */
export const IncludeRewardStatus$inboundSchema: z.ZodNativeEnum<
  typeof IncludeRewardStatus
> = z.nativeEnum(IncludeRewardStatus);

/** @internal */
export const IncludeRewardStatus$outboundSchema: z.ZodNativeEnum<
  typeof IncludeRewardStatus
> = IncludeRewardStatus$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace IncludeRewardStatus$ {
  /** @deprecated use `IncludeRewardStatus$inboundSchema` instead. */
  export const inboundSchema = IncludeRewardStatus$inboundSchema;
  /** @deprecated use `IncludeRewardStatus$outboundSchema` instead. */
  export const outboundSchema = IncludeRewardStatus$outboundSchema;
}

/** @internal */
export const IncludeActionNnsFunction$inboundSchema: z.ZodNativeEnum<
  typeof IncludeActionNnsFunction
> = z.nativeEnum(IncludeActionNnsFunction);

/** @internal */
export const IncludeActionNnsFunction$outboundSchema: z.ZodNativeEnum<
  typeof IncludeActionNnsFunction
> = IncludeActionNnsFunction$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace IncludeActionNnsFunction$ {
  /** @deprecated use `IncludeActionNnsFunction$inboundSchema` instead. */
  export const inboundSchema = IncludeActionNnsFunction$inboundSchema;
  /** @deprecated use `IncludeActionNnsFunction$outboundSchema` instead. */
  export const outboundSchema = IncludeActionNnsFunction$outboundSchema;
}

/** @internal */
export const GetApiV3ProposalsFormat$inboundSchema: z.ZodNativeEnum<
  typeof GetApiV3ProposalsFormat
> = z.nativeEnum(GetApiV3ProposalsFormat);

/** @internal */
export const GetApiV3ProposalsFormat$outboundSchema: z.ZodNativeEnum<
  typeof GetApiV3ProposalsFormat
> = GetApiV3ProposalsFormat$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3ProposalsFormat$ {
  /** @deprecated use `GetApiV3ProposalsFormat$inboundSchema` instead. */
  export const inboundSchema = GetApiV3ProposalsFormat$inboundSchema;
  /** @deprecated use `GetApiV3ProposalsFormat$outboundSchema` instead. */
  export const outboundSchema = GetApiV3ProposalsFormat$outboundSchema;
}

/** @internal */
export const GetApiV3ProposalsIncludeTopic$inboundSchema: z.ZodNativeEnum<
  typeof GetApiV3ProposalsIncludeTopic
> = z.nativeEnum(GetApiV3ProposalsIncludeTopic);

/** @internal */
export const GetApiV3ProposalsIncludeTopic$outboundSchema: z.ZodNativeEnum<
  typeof GetApiV3ProposalsIncludeTopic
> = GetApiV3ProposalsIncludeTopic$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3ProposalsIncludeTopic$ {
  /** @deprecated use `GetApiV3ProposalsIncludeTopic$inboundSchema` instead. */
  export const inboundSchema = GetApiV3ProposalsIncludeTopic$inboundSchema;
  /** @deprecated use `GetApiV3ProposalsIncludeTopic$outboundSchema` instead. */
  export const outboundSchema = GetApiV3ProposalsIncludeTopic$outboundSchema;
}

/** @internal */
export const GetApiV3ProposalsRequest$inboundSchema: z.ZodType<
  GetApiV3ProposalsRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  limit: z.number().int().default(50),
  max_proposal_index: z.nullable(z.number().int()).default(null),
  include_action: z.array(IncludeAction$inboundSchema).optional(),
  include_status: z.array(GetApiV3ProposalsIncludeStatus$inboundSchema)
    .optional(),
  proposer: z.nullable(z.number().int()).default(null),
  manage_neuron_id: z.nullable(z.number().int()).default(null),
  offset: z.number().int().default(0),
  include_reward_status: z.array(IncludeRewardStatus$inboundSchema).optional(),
  include_action_nns_function: z.array(IncludeActionNnsFunction$inboundSchema)
    .optional(),
  format: GetApiV3ProposalsFormat$inboundSchema.default("json"),
  include_topic: z.array(GetApiV3ProposalsIncludeTopic$inboundSchema)
    .optional(),
}).transform((v) => {
  return remap$(v, {
    "max_proposal_index": "maxProposalIndex",
    "include_action": "includeAction",
    "include_status": "includeStatus",
    "manage_neuron_id": "manageNeuronId",
    "include_reward_status": "includeRewardStatus",
    "include_action_nns_function": "includeActionNnsFunction",
    "include_topic": "includeTopic",
  });
});

/** @internal */
export type GetApiV3ProposalsRequest$Outbound = {
  limit: number;
  max_proposal_index: number | null;
  include_action?: Array<string> | undefined;
  include_status?: Array<string> | undefined;
  proposer: number | null;
  manage_neuron_id: number | null;
  offset: number;
  include_reward_status?: Array<string> | undefined;
  include_action_nns_function?: Array<string> | undefined;
  format: string;
  include_topic?: Array<string> | undefined;
};

/** @internal */
export const GetApiV3ProposalsRequest$outboundSchema: z.ZodType<
  GetApiV3ProposalsRequest$Outbound,
  z.ZodTypeDef,
  GetApiV3ProposalsRequest
> = z.object({
  limit: z.number().int().default(50),
  maxProposalIndex: z.nullable(z.number().int()).default(null),
  includeAction: z.array(IncludeAction$outboundSchema).optional(),
  includeStatus: z.array(GetApiV3ProposalsIncludeStatus$outboundSchema)
    .optional(),
  proposer: z.nullable(z.number().int()).default(null),
  manageNeuronId: z.nullable(z.number().int()).default(null),
  offset: z.number().int().default(0),
  includeRewardStatus: z.array(IncludeRewardStatus$outboundSchema).optional(),
  includeActionNnsFunction: z.array(IncludeActionNnsFunction$outboundSchema)
    .optional(),
  format: GetApiV3ProposalsFormat$outboundSchema.default("json"),
  includeTopic: z.array(GetApiV3ProposalsIncludeTopic$outboundSchema)
    .optional(),
}).transform((v) => {
  return remap$(v, {
    maxProposalIndex: "max_proposal_index",
    includeAction: "include_action",
    includeStatus: "include_status",
    manageNeuronId: "manage_neuron_id",
    includeRewardStatus: "include_reward_status",
    includeActionNnsFunction: "include_action_nns_function",
    includeTopic: "include_topic",
  });
});

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3ProposalsRequest$ {
  /** @deprecated use `GetApiV3ProposalsRequest$inboundSchema` instead. */
  export const inboundSchema = GetApiV3ProposalsRequest$inboundSchema;
  /** @deprecated use `GetApiV3ProposalsRequest$outboundSchema` instead. */
  export const outboundSchema = GetApiV3ProposalsRequest$outboundSchema;
  /** @deprecated use `GetApiV3ProposalsRequest$Outbound` instead. */
  export type Outbound = GetApiV3ProposalsRequest$Outbound;
}

export function getApiV3ProposalsRequestToJSON(
  getApiV3ProposalsRequest: GetApiV3ProposalsRequest,
): string {
  return JSON.stringify(
    GetApiV3ProposalsRequest$outboundSchema.parse(getApiV3ProposalsRequest),
  );
}

export function getApiV3ProposalsRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetApiV3ProposalsRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetApiV3ProposalsRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetApiV3ProposalsRequest' from JSON`,
  );
}
